import { get, post, put, del } from './api';

//  Create a new product
export const createProduct = (data) => {
  return post('/products', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Get all products with pagination

export const getAllProducts = (
page = 1,
limit = 10,
name = '',
code = '',
brand = '',
category = '',
status = '',
sortField = 'id',      
sortOrder = 'desc'     
) => {
const params = new URLSearchParams();
params.append('page', page);
params.append('limit', limit);
if (name) params.append('name', name);
if (code) params.append('short_code', code);
if (brand) params.append('brand_id', brand);
if (category) params.append('category_id', category);
if (status !== '') params.append('is_active', status);
if (sortField) params.append('sort_field', sortField);
if (sortOrder) params.append('sort_order', sortOrder);

return get(`/products?${params.toString()}`);
};



//  Get a product by ID
export const getProductById = (id) => {
  return get(`/products/${id}`);
};

//  Update a product
export const updateProduct = (id, data, isMultipart = false) => {
  return post(`/products/${id}/update`, data, {
    headers: {
      "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
    },
  });
};

//  Delete a product 
export const deleteProduct = (id) => {
  return del(`/products/${id}`);
};


// download product import template
export const downloadProductTemplate = () => {
  return get('/products/import/template', {
    responseType: 'blob', 
  });
};

// import products in bulk
export const importProducts = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return post('/products/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000, 
  });
};
// Toggle product favourite status
export const toggleFavourite = (id) => {
  return post('/products/' + id + '/toggle-favourite');
};
